import { Platform } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { Device } from '@ionic-native/device/ngx';
import { DeviceUUID } from '../../../assets/js/device-uuid.js';

export interface DeviceInfo {
  os: string;
  platform: string;
  browser: string;
  version: string;
  device: string;
}
@Injectable({
  providedIn: 'root',
})
export class FingerPrintService {
  private deviceFingerPrint;
  private deviceInfo: DeviceInfo;

  constructor(private device: Device, private platform: Platform) {
    this.setFingerPrint();
  }

  private setFingerPrint() {
    if (this.deviceFingerPrint) return;
    // get fingerprints of device
    const uuid = new DeviceUUID().get();
    this.deviceFingerPrint = uuid;
  }

  public getfingerPrint(): string {
    this.setFingerPrint();
    return this.deviceFingerPrint;
  }

  /* istanbul ignore next reason: cannot modified the system configurations */
  public isSafariBrowser(): boolean {
    const ua = new DeviceUUID();
    ua.Agent.source = navigator.userAgent.replace(/^\s*/, '').replace(/\s*$/, '');
    const browser = ua.getBrowser(ua.Agent.source);
    if (browser === 'Safari') return true;
    return false;
  }

  getDeviceInfo(): DeviceInfo {
    if (this.deviceInfo) return this.deviceInfo;
    const ua = new DeviceUUID();
    const source = (ua.Agent.source = navigator.userAgent.replace(/^\s*/, '').replace(/\s*$/, ''));
    ua.Agent.browser = ua.getBrowser(ua.Agent.source);
    ua.Agent.version = ua.getBrowserVersion(ua.Agent.source);
    this.deviceInfo = {
      os: ua.getOS(source),
      device: ua.getPlatform(source),
      browser: ua.getBrowser(source),
      version: this.device.version ?? ua.getBrowserVersion(source),
      platform: this.getDevicePlatfrom(),
    };
    return this.deviceInfo;
  }

  getDevicePlatfrom(): string {
    let platform = '';
    if (this.platform.is('cordova')) {
      if (this.platform.is('ios')) platform = 'iOS app';
      else platform = 'Android app';
    } else platform = 'Browser';
    return platform;
  }
}
